import React, {Component} from 'react'
import NewClient from './NewClient'
import {message} from 'antd/lib/index'
import Members from '../../../api/Members'
import Clients from '../../../api/Sales/Clients'
import {isEmpty, omit, pick} from 'lodash'

class NewClientCont extends Component {
  state = {
    loadingMembers: false,
    currentStep: 0,
    members: [],
    cachedMembers: [],
    selection: [],
    submitting: false,
    client: {},
  }
  api = new Clients()
  membersApi = new Members()
  detailsFormRef = React.createRef()

  async componentDidMount() {
    this.fetchMembers()
  }

  fetchMembers = async () => {
    try {
      this.setState({
        fetchingMembers: true,
      })
      const response = await this.membersApi.phonebook()
      const members = await response.json()
      this.setState({
        fetchingMembers: false,
        members,
        cachedMembers: members,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({
        fetchingMembers: false,
      })
    }
  }
  prev = () => {
    this.setState(prvState => ({currentStep: prvState.currentStep - 1}))
  }
  skip = () => {
    if (isEmpty(this.state.type)) {
      message.error('Select a type first')
    } else {
      this.setState({
        currentStep: 1,
        member: {new: true},
      })
    }
  }
  next = async () => {
    let valid = false
    const {currentStep} = this.state
    switch (currentStep) {
      case 0:
        valid = this.checkExistingForm()
        break
      default:
        valid = true
    }
    if (valid)
      this.setState(prvState => ({currentStep: prvState.currentStep + 1}))
  }
  submit = async () => {
    try {
      let member = await this.checkPersonalDetailsForm()
      this.setState({
        submitting: true,
      })
      let {client} = this.state
      const clientResp = await this.api.create({member, client})
      if (clientResp) {
        message.success('Created!')
        this.setState({submitting: false})
        setTimeout(() => {
          const pathname = '/clients/list/'
          window.location = `#${pathname}`
        }, 300)
      }
    } catch (error) {
      console.error(error)
      message.error(error.errorMessage)
      this.setState({submitting: false})
    }
  }

  toggleSelection = key => {
    const selection = [key]
    this.setState({selection})
  }
  isSelected = key => {
    return this.state.selection.includes(key)
  }
  onChangeType = type => {
    this.setState(prvState => ({
      type,
      members: type
        ? prvState.cachedMembers.filter(m => m.kind === type)
        : prvState.cachedMembers,
    }))
  }
  checkExistingForm = () => {
    if (this.state.selection.length < 1) message.error('Select a contact')
    else {
      this.setState(prvState => ({
        member: prvState.cachedMembers.find(
          m => m._id === prvState.selection[0],
        ),
      }))
      return true
    }
  }
  checkPersonalDetailsForm = () => {
    return new Promise((res, rej) => {
      this.detailsFormRef.current.validateFields((err, values) => {
        if (!err) {
          const member = pick(this.state.member, [
            '_id',
            '_rev',
            '_key',
            'kind',
            'new',
          ])
          res(Object.assign({}, member, values, {kind: this.state.type}))
        }
      })
    })
  }

  render() {
    return (
      <NewClient
        {...this.state}
        {...pick(this, [
          'fetchMembers',
          'fetchMembers',
          'toggleSelection',
          'isSelected',
          'onChangeType',
          'prev',
          'skip',
          'next',
          'submit',
          'detailsFormRef',
        ])}
      />
    )
  }
}

NewClientCont.propTypes = {}
NewClientCont.defaultProps = {}

export default NewClientCont
